













































import { api } from '@/plugins/api';
import {
  defineComponent,
  reactive,
  Ref,
  ref,
  UnwrapRef
} from '@vue/composition-api';
import store from '../store';
import groupby from 'lodash.groupby';

export default defineComponent({
  name: 'UserTree',
  props:{
    inviteRole:{
      type: String,
      default:()=>"TrafficPolice"
    }
  },
  setup(props, { emit }) {
    const list: Ref<any[]> = ref([]);
    const loading = ref(false);
    console.log('角色'+props);
    
    const loadData = async () => {
      loading.value = true;
      const data = await api.video.trtc.onlineUsers.getOnlineUsers.r();
      let groups = groupby(data, it => it.roleName);
      let newGroups = {};
      console.log(groups);
      
      Object.keys(groups).forEach(key => {
        let arr:any = [];
        groups[key].map((el:any)=> {
            let hasId = false;
            if (key ==='保险员') {
              // 保险员只需要在线的
              if (el.onLine) {
                arr.length && arr.forEach((item:any)=>{
                  if (el.userId === item.userId) {
                    hasId = true;
                  }
                });
                if (!hasId) {
                  arr.push(el);
                }
              }
            }else {
              // 交警全部显示
              arr.length && arr.forEach((item:any)=>{
                if (el.userId === item.userId) {
                  hasId = true;
                }
              });
              if (!hasId) {
                arr.push(el);
              }
            }
        });
        if (key) {
          newGroups[key] = arr;
        }
      });
      list.value = Object.keys(newGroups).map(key => ({
        label: `${key}（${newGroups[key].length}）`,
        value: key,
        type: 'group',
        children: newGroups[key].map((it, index) => ({
          label: it.userName,
          value: it.userName,
          type: 'user',
          isOnline: it.onLine,
          roleName: it.roleName,
          extension: it.extension,
          index
        }))
      }));
      loading.value = false;
      
    };
    console.log(list);
    const getIconText = (node, nodeData) => {
      return nodeData.label.substr(nodeData.label.length - 1);
    };
    const selectedIds: UnwrapRef<any[]> = reactive([]);
    const selectedName: UnwrapRef<any[]> = reactive([]);
    const selectNode = nodeData => {
      console.log(nodeData);
      
      if (nodeData.roleName === '交警' || nodeData.value === '交警') {
        store.commit('app/SET_ISINVITER', true);
      }else {
        store.commit('app/SET_ISINVITER', false);
      }
      if (nodeData.type === 'user') {
        if (nodeData.roleName === '保险员') {
          if (selectedIds.includes(nodeData.value)) {
            selectedIds.splice(selectedIds.indexOf(nodeData.value), 1);
            selectedName.splice(selectedName.indexOf(nodeData.roleName), 1);
          } else {
            selectedIds.push(nodeData.value);
            selectedName.push(nodeData.roleName);
          }
        } else if (nodeData.roleName === '交警') {
          if (selectedName.includes('交警')) {
            selectedIds.splice(selectedIds.length - 1, 1);
            selectedName.splice(selectedName.length - 1, 1);
            selectedIds.push(nodeData.value);
            selectedName.push(nodeData.roleName);
          } else {
            selectedIds.push(nodeData.value);
            selectedName.push(nodeData.roleName);
          }
        }

      }
      emit('input', {selectedName:[...selectedName], selectedIds:[...selectedIds], extension:nodeData.extension});
    };
    const isNodeChecked = data => {
      return selectedIds.includes(data.value);
    };
    return {
      list,
      loadData,
      loading,
      getIconText,
      selectNode,
      selectedIds,
      isNodeChecked
    };
  }
});
